import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    BalloonMessage,
} from "client/components"

const CloudDriveAuthResponse = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const response = window.location.search
    const param1 = "?code="
    const param2 = "&scope="

    // Google drive uses "code" and "scope" in the response
    // MS OneDrive uses only "code"

    const start = response.indexOf(param1) + param1.length
    const end = response.indexOf(param2)
    const code = decodeURIComponent(response.substring(start, end > 0 ? end : response.length))

    const copyToClipboard = () => {
        navigator.clipboard.writeText(code)
        BalloonMessage(lang.copiedToClipboard)
    }

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.response}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <p>{code}</p>
                    <Button row onClick={copyToClipboard}>{lang.copy}</Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default CloudDriveAuthResponse
